module.exports = __webpack_public_path__ + "static/media/membership-delivery.e2ec008e.png";